import { useEffect, useState } from "react";
import { Badge, Modal } from "react-bootstrap";
import Store, { useAppDispatch } from "../../redux";
import { HttpService } from "../../services/HttpService";
import Spinner from "./spinner";
import ButtonSubmit from "./buttonSubmit";
import { useTranslation } from "react-i18next";
import { loadCategoryTimeslot } from "../../redux/reducer/timeslotReducer";

const NewGroupLinkModal = (props: any) => {
  const dispacth = useAppDispatch();
  const { t } = useTranslation();
  const groupLinkValueNewActivation = props.groupLinkValueNewActivation;
  const [verificationFeedback, setVerificationFeedback] = useState([]);
  const [simpleInterface, setSimpleInterface] = useState(false);
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [error, setError] = useState("");

  const checkNewActivation = async () => {
    try {
      setError("");
      setMainCategoryId("");
      const eventId = Store.getState().login.eventId;
      if (eventId) {
        const response = await HttpService.post(
          `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/grouplink/verify`,
          { groupLinkValue: groupLinkValueNewActivation }
        );
        const verificationResult = response.data.result;
        const categoryWithTimeslotExists = verificationResult.find((vr: any) =>
          vr.futureTimeslots > 0
        );
        if (!categoryWithTimeslotExists) {
          setSimpleInterface(true);
        }
        setVerificationFeedback(response.data.result)
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  const activation = async () => {
    try {
      setVerificationFeedback([]);
      const eventId = Store.getState().login.eventId;
      if (eventId) {
        const response = await HttpService.post(
          `${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/grouplink/activation`,
          {
            groupLinkValue: groupLinkValueNewActivation,
            mainCategoryId: simpleInterface ? verificationFeedback[0]["categoryId"] : mainCategoryId,
          }
        );
        props.onClose();
        await dispacth(loadCategoryTimeslot(false));
      }
    }
    catch (error: any) {
      setError(error.response?.data?.result?.message || String(error));
    }
  }

  useEffect(() => {
    checkNewActivation()
  }, []);

  return (
    <Modal show={true}
      keyboard={false} // Prevent modal dismiss with `esc` key.
      backdrop="static" // Prevent modal dismiss clicking on backdrop.
    >
      <Modal.Header>
        <Modal.Title>{t("new-group-link-modal.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <div className="col-lg-12">
          {error && <>
            <p>{error}</p>
            <p>{t("new-group-link-modal.error-hint")}</p>
          </>}
        </div>}

        {!error && <div className="col-lg-12">
          {verificationFeedback.length === 0 && !error && <>
            <p>{t("new-group-link-modal.check-in-progress")}</p><Spinner />
          </>}

          {simpleInterface && <>
            {verificationFeedback.map((f: any) => <div>
              <p className="p-1" key={f.categoryId}>
                <b>{f.categoryName}</b>
                {f.newActivation && <>&nbsp;<Badge bg="secondary">
                  {t("new-group-link-modal.new-link")}
                </Badge></>}
                <br />
                {t("new-group-link-modal.future-timeslots")} {f.futureTimeslots}<br />
                {t("new-group-link-modal.future-timeslots-with-booking")} {f.futureNonEmptyTimeslots}
              </p>
            </div>)}
          </>}

          {!simpleInterface && verificationFeedback.length > 0 && <>
            <p>{t("new-group-link-modal.choose-agenda")}</p>

            {verificationFeedback.map((f: any) => <div>
              {/* Checkbox. */}
              <div className="CheckBoxLable row m-0" key={f.categoryId}>
                <div className={`Marker ${(mainCategoryId === f.categoryId) ? "Active" : ""}`}
                  onClick={() => setMainCategoryId((mainCategoryId === f.categoryId) ? null : f.categoryId)}
                >
                </div>
                <p className="p-1">
                  <b>{f.categoryName}</b>
                  {f.newActivation && <>&nbsp;<Badge bg="secondary">
                    {t("new-group-link-modal.new-link")}
                  </Badge></>}
                  <br />
                  {t("new-group-link-modal.future-timeslots")} {f.futureTimeslots}<br />
                  {t("new-group-link-modal.future-timeslots-with-booking")} {f.futureNonEmptyTimeslots}
                </p>
              </div>
            </div>)}

            <p>{t("new-group-link-modal.verification-desc-copy-main")}</p>
            <p>{t("new-group-link-modal.verification-desc-delete-other")}</p>
          </>}

        </div>}
      </Modal.Body>
      <Modal.Footer>
        <>
          {error && <ButtonSubmit
            textButton={t("new-group-link-modal.error-back")}
            handleChange={() => checkNewActivation()}
          />}
          {!error && <ButtonSubmit
            disabled={!mainCategoryId && !simpleInterface}
            textButton={t("new-group-link-modal.continue")}
            handleChange={() => activation()}
          />}
        </>
      </Modal.Footer>
    </Modal >
  )
}

export default NewGroupLinkModal;
